<app-dialog-container>
  <div fxLayout="column" fxLayoutGap="24px">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <h2 mat-dialog-title>Gerar Contrato para Parceiro</h2>
    </div>

    <div mat-dialog-content fxLayout="column" fxLayoutGap="24px">
      <!-- Informações do Parceiro -->
      <div class="section-card">
        <div fxLayout="column" fxLayoutGap="16px">
          <h3>Informações do Parceiro</h3>
          <div fxLayout="row wrap" fxLayoutGap="16px grid">
            <div fxFlex="calc(50% - 16px)" fxFlex.lt-md="100">
              <strong>Nome/Razão Social:</strong> {{ data.entity.name ||
              data.entity.companyName || data.entity.tradingName ||
              'Não informado' }}
            </div>
            <div fxFlex="calc(50% - 16px)" fxFlex.lt-md="100">
              <strong>Documento (CPF/CNPJ):</strong> {{ data.entity.document ||
              'Não informado' }}
            </div>
            <div fxFlex="calc(50% - 16px)" fxFlex.lt-md="100">
              <strong>Email:</strong> {{ data.entity.email || 'Não informado' }}
            </div>
            <div fxFlex="calc(50% - 16px)" fxFlex.lt-md="100">
              <strong>Telefone:</strong> {{ data.entity.cellPhone ||
              data.entity.phone || 'Não informado' }}
            </div>
          </div>
        </div>
      </div>

      <div class="section-card">
        <app-contract-role-selection
          [partner]="partnerData"
          [currentSelection]="selectedRole"
          (roleSelected)="onRoleSelected($event)"
          (removeContractClicked)="removeExistingContract($event)">
        </app-contract-role-selection>
      </div>

      <!-- Assinaturas -->
      <div class="section-card">
        <div fxLayout="column" fxLayoutGap="16px">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <h3>Signatários do Contrato</h3>
            <button mat-raised-button color="primary" (click)="addSignature()"
              [disabled]="isLoading">
              <mat-icon>person_add</mat-icon>
              Adicionar Signatário
            </button>
          </div>

          <div class="table-container">
            <table mat-table [dataSource]="signatures"
              class="signatures-table mat-elevation-z1">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Nome</th>
                <td mat-cell *matCellDef="let element"
                  [class.bold-text]="element.isDefaultContracted || element.isContracted">
                  {{element.name || 'Não informado'}}
                </td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>Email</th>
                <td mat-cell *matCellDef="let element">{{element.email ||
                  'Não informado'}}</td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Papel</th>
                <td mat-cell *matCellDef="let element">
                  <span class="signature-type-label"
                    [ngClass]="getSignatureTypeColor(element.type)">
                    {{getSignatureTypeLabel(element.type)}}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="document">
                <th mat-header-cell *matHeaderCellDef>Documento</th>
                <td mat-cell *matCellDef="let element">{{element.document ||
                  'Não informado'}}</td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div fxLayout="row" fxLayoutGap="8px" class="action-buttons">
                    <button mat-icon-button color="primary"
                      (click)="editSignature(element, i)"
                      [disabled]="element.isContracted || element.isDefaultContracted || isLoading"
                      matTooltip="{{ element.isDefaultContracted ? 'Não é possível editar a Contratada' :
                        element.isContracted ? 'Não é possível editar o Contratante (Parceiro)' : 'Editar signatário' }}">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn"
                      (click)="removeSignature(i)"
                      [disabled]="element.isContracted || element.isDefaultContracted || isLoading"
                      matTooltip="{{ element.isDefaultContracted ? 'Não é possível remover a Contratada' :
                        element.isContracted ? 'Não é possível remover o Contratante (Parceiro)' : 'Remover signatário' }}">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              <!-- Linha para quando não houver dados -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data-cell"
                  [attr.colspan]="displayedColumns.length">
                  Nenhum signatário adicionado ainda (além dos padrões).
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center"
      fxLayoutGap="16px">
      <button mat-stroked-button (click)="close()">Cancelar</button>

      <button mat-raised-button color="primary" (click)="generateContract()"
        [disabled]="isLoading || signatures.data.length === 0 || !selectedRole">
        <mat-icon *ngIf="!isLoading">picture_as_pdf</mat-icon>
        Gerar Contrato
      </button>
    </div>
  </div>
</app-dialog-container>
